import React from 'react';
import { Alert, Button } from 'antd';
import { displayQuotationRevisionLabel, formatQuotationPrintIdentity } from '@/utils/quotationRevisionPolicy';
import type { Quotation } from '@/services/quotation.service';

type Props = {
  quotation: Quotation;
  currentOffer?: Quotation | null;
  onOpenCurrent?: () => void;
};

export const QuotationHistoricalBanner: React.FC<Props> = ({
  quotation,
  currentOffer,
  onOpenCurrent,
}) => {
  const isSuperseded =
    quotation.status === 'Revised' || !!quotation.superseded_at;

  if (!isSuperseded) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
      message="This quotation revision has been superseded."
      description={
        currentOffer ? (
          <span>
            Current customer offer:{' '}
            <strong>
              {formatQuotationPrintIdentity(
                currentOffer.quotation_number,
                currentOffer.revision_number
              )}
            </strong>{' '}
            ({currentOffer.status})
          </span>
        ) : (
          'Open the latest revision in this family.'
        )
      }
      action={
        currentOffer && onOpenCurrent ? (
          <Button size="small" onClick={onOpenCurrent}>
            Open Current Revision ({displayQuotationRevisionLabel(currentOffer.revision_number)})
          </Button>
        ) : undefined
      }
    />
  );
};

export default QuotationHistoricalBanner;
